const experimentMap = [
    {
        name: "Test123",
        variants: [
            {
                name: "Default",
                weight: 1,
            },
            {
                name: "B",
                weight: 1,
            },
            {
                name: "C",
                weight: 2,
            },
        ],
        resolve: variant => {},
    },
];

module.exports = experimentMap;
